import Lands from "../../../../src/data/articles/a-guide-to-battle-box/Lands.tsx";
import BattleBoxList from "../../../../src/data/articles/a-guide-to-battle-box/BattleBoxList.tsx";
import * as React from 'react';
export default {
  Lands,
  BattleBoxList,
  React
};